import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Finder bar's unique contribution-ref in the containing DOM tree.
   *
   * @type {String}
   * @default undefined
   */
  contributesTo: {
    type: String,
    default: undefined,
  },
  /**
   * Menu label for the applied free-text criterion. Defaults to the translated Query label.
   *
   * @type {String}
   * @default undefined
   */
  queryLabel: {
    type: String,
    default: undefined,
  },
  /**
   * URL of the events autocomplete payload. Fetched once up front; all
   * matching happens client-side.
   *
   * @type {String}
   * @required true
   */
  src: {
    type: String,
    required: true,
  },
  /**
   * Placeholder text for the search field.
   *
   * @type {String}
   * @default undefined
   */
  placeholder: {
    type: String,
    default: undefined,
  },
  /**
   * Prefills the search field's text (e.g. the current `query` param on the
   * results page). With contributes-to it also seeds the applied query and form
   * value. Otherwise it prefills text only until the user commits an edit.
   *
   * @type {String}
   * @default undefined
   */
  search: {
    type: String,
    default: undefined,
  },
  /**
   * Sets a `data-testid` on the inner search input. Pass a catalog value from
   * the mounting view (see `app/frontend/src/test-ids.json`).
   *
   * @type {String}
   * @default undefined
   */
  inputTestId: {
    type: String,
    default: undefined,
  },
  /**
   * Disable the search field. While disabled, neither the query nor any
   * staged filter inputs submit form values.
   *
   * @type {Boolean|String}
   * @default false
   */
  disabled: booleanAttribute(),
  /**
   * Make the search field readonly.
   *
   * @type {Boolean|String}
   * @default false
   */
  readonly: booleanAttribute(),
});
